<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-overlay(:value="saving" absolute)
                v-progress-circular(indeterminate size="64")
            v-card-title.title.caption--text {{title}}
            v-container(tag="v-card-text" gris-list-lg)
                v-form(id="form" ref="refForm" @submit.prevent="onSubmit")
                    v-layout(wrap)
                        v-flex(xs12 layout justify-start v-if="!!user")
                            v-card(style="width: 100%")
                                v-list-item
                                    v-list-item-avatar(color='grey').elevation-3
                                        v-img(:src="user.avatar ? user.avatar : userAvatarColor")
                                    v-list-item-content
                                        v-list-item-title.title {{user.name}}
                                        v-list-item-subtitle {{user.company.code}}

                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_all" hide-details @change="onSelectAll"
                            :label='$t("pages.settings.permission.table.headers.perm_all.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_setting" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_setting.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_new_button" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_new_button.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_download" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_download.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_share_permission" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_share_permission.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_manage_file" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_manage_file.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_delete_file" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_delete_file.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_create_chat_room" hide-details :disabled="perm_all"
                                :label='$t("pages.settings.permission.table.headers.perm_create_chat_room.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_edit_chat_room" hide-details :disabled="perm_all"
                                :label='$t("pages.settings.permission.table.headers.perm_edit_chat_room.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_delete_chat_room" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_delete_chat_room.title")')
                        v-flex(xs12 sm6)
                            v-switch(v-model="perm_drop_file_at_sheet" hide-details :disabled="perm_all"
                            :label='$t("pages.settings.permission.table.headers.perm_drop_file_at_sheet.title")')
            v-layout(tag="v-card-actions")
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(type="submit" form="form" color="primary" depressed).px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.save')}}
</template>

<script>
import rules from "../../mixins/rules";
import general from "../../mixins/general";
import crud from "../../mixins/crud";

export default {
  name: "EditDialog",
  mixins: [rules, general, crud],
  data() {
    return {
      mode: "edit",
      dialog: false,
      saving: false,
      user: null,
      perm_all: false,
      perm_setting: false,
      perm_new_button: false,
      perm_download: false,
      perm_share_permission: false,
      perm_manage_file: false,
      perm_delete_file: false,
      perm_create_chat_room: false,
      perm_edit_chat_room: false,
      perm_delete_chat_room: false,
      perm_drop_file_at_sheet: false
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    },
    title: {
      get() {
        return this.$t(`pages.settings.permission.dialog.title.${this.mode}`);
      }
    }
  },
  methods: {
    clear() {
      this.user = null;
      this.perm_all = false;
      this.perm_setting = false;
      this.perm_new_button = false;
      this.perm_download = false;
      this.perm_share_permission = false;
      this.perm_manage_file = false;
      this.perm_delete_file = false;
      this.perm_create_chat_room = false;
      this.perm_edit_chat_room = false;
      this.perm_delete_chat_room = false;
      this.perm_drop_file_at_sheet = false;
    },
    show(user) {
      this.clear();
      this.user = { ...user };
      this.perm_all = this.user.perm_all;
      this.perm_setting = this.user.perm_setting;
      this.perm_new_button = this.user.perm_new_button;
      this.perm_download = this.user.perm_download;
      this.perm_share_permission = this.user.perm_share_permission;
      this.perm_manage_file = this.user.perm_manage_file;
      this.perm_delete_file = this.user.perm_delete_file;
      this.perm_create_chat_room = this.user.perm_create_chat_room;
      this.perm_edit_chat_room = this.user.perm_edit_chat_room;
      this.perm_delete_chat_room = this.user.perm_delete_chat_room;
      this.perm_drop_file_at_sheet = this.user.perm_drop_file_at_sheet;
      this.onSelectAll(this.perm_all);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    onSelectAll(value) {
      if (value) {
        this.perm_setting = true;
        this.perm_new_button = true;
        this.perm_download = true;
        this.perm_share_permission = true;
        this.perm_manage_file = true;
        this.perm_delete_file = true;
        this.perm_create_chat_room = true;
        this.perm_edit_chat_room = true;
        this.perm_delete_chat_room = true;
        this.perm_drop_file_at_sheet = true;
      }
    },
    onSubmit() {
      this.$confirm(this.$t("messages.saveConfirmation")).then(value => {
        if (value) {
          this.saving = true;
          setTimeout(() => {
            const data = {
              perm_all: this.perm_all,
              perm_setting: this.perm_setting,
              perm_new_button: this.perm_new_button,
              perm_download: this.perm_download,
              perm_share_permission: this.perm_share_permission,
              perm_manage_file: this.perm_manage_file,
              perm_delete_file: this.perm_delete_file,
              perm_create_chat_room: this.perm_create_chat_room,
              perm_edit_chat_room: this.perm_edit_chat_room,
              perm_delete_chat_room: this.perm_delete_chat_room,
              perm_drop_file_at_sheet: this.perm_drop_file_at_sheet
            };
            this.axios({
              url: `users/${encodeURIComponent(this.user.id)}/permissions`,
              method: `patch`,
              data
            })
              .then(response => {
                this.saving = false;
                this.close();
                this.$emit("saved", response.data.data);
              })
              .catch(error => {
                this.saving = false;
                if (this.mode === "create") this.saveErrorHandler(error);
                else this.updateErrorHandler(error);
              });
          }, 500);
        }
      });
    }
  }
};
</script>
